<p>events-mld works!</p>
<app-navbar></app-navbar>

<section class="blog-area ptb-100">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      Renovated Occupational Therapy (OT) Unit of Proyash-Chattogram
    </h3>
    <hr />
    <div>
      <p style="color: white;" >
        Renovated Occupational Therapy (OT) Unit of Proyash-Chattogram has
        generated interest among the therapists, educators and parents. Thanks
        to all who endeavored to convert it into a modern and workable entity.
      </p>
      <section class="blog-area gallery-section">
        <div class="container">
          <div class="container">
            <div class="gallery-container">
              <div class="gallery">
                <a
                  *ngFor="let image of images"
                  class="gallery__item"
                  href="{{ image.src }}"
                  [title]="image.alt"
                >
                  <img
                    [src]="image.thumbnail"
                    [alt]="image.alt"
                    class="popup-btn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
